import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { disableContextMenu } from 'disable-context-menu';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueYandexMetrika from 'vue-yandex-metrika'

// import 'video.js/dist/video-js.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(VueYandexMetrika, {
  id: 42444904,
  router: router,
  env: process.env.NODE_ENV
})

if (process.env.NODE_ENV !== 'development') {
  disableContextMenu();
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
